<template>
  <div class="search-form">
    <transition name="fly">
      <div @click="toggleSearch()" v-show="searchHidden">
        <br/>
        <p class="form-control text-muted fake-input interactive-cursor">
          Filter...
          <span class="text-muted fa fa-search fa-fw pull-right"></span>
        </p>
      </div>
    </transition>
    <transition name="fly">
      <div class="clearfix" v-show="!searchHidden">
        <vue-form
          :options="formOptions"
          @load="search()"
          ref="searchForm"
          v-if="formOptions">
          <span slot="title">
            Filter {{ formOptions.objectName }}
            <span
              class="fa fa-times float-right fa-lg text-danger interactive-cursor"
              @click="toggleSearch()">
            </span>
          </span>
          <div class="col" slot="actions">
            <button class="btn btn-info" type="button" @click="search()">
              <span class="fa fa-sync"></span> Refresh {{ formOptions.objectName }}
            </button>
          </div>
        </vue-form>
      </div>
    </transition>
    <div class="alert alert-danger" v-if="!results.length">
      <p>
       {{ noResults }}
      </p>
    </div>
    <template v-else>
      <button
        class="btn btn-default"
        v-if="allowToggle"
        @click="$emit('toggleDisplay')">
        <span
          class="fa fa-fw"
          :class="!tableDisplay ? 'fa-bars' : 'fa-table'">
        </span>
        Toggle Display
      </button>
      <div class="text-center">
        <paging-input @change="updatePage($event)" :options="{
          totalResults,
          current,
          limit: limit}">
        </paging-input>
      </div>
      <responsive-table
        :hideTitle="true"
        :table="{ columns }"
        v-if="tableDisplay">
        <template slot="rows">
          <template v-for="(row, i) in results">
            <component
              :key="i"
              :is="parseType(formOptions.permalink) + '-row'"
              :object="row"
              :index="i"
              @edit="editObject($event)"
              @deleteObject="deleteObject($event)">
            </component>
          </template>
        </template>
      </responsive-table>
      <div class="row" v-else>
        <template v-for="(object, i) in results">
          <div class="col" v-if="isNewDay(object, i) && showDates" :key="i + 'date'">
            <h3 class="border border-dark border-top-0 border-left-0 border-right-0 pb-2">
              {{ object.createdAt | date_format }}
            </h3>
          </div>
          <component
            :key="i" :is="parseType(formOptions.permalink) + '-display'"
            :object="object">
          </component>
        </template>
      </div>
      <div class="text-center">
        <br/>
        
        <paging-input @change="updatePage($event)" :options="{
          totalResults,
          current,
          limit: limit}">
        </paging-input>
      </div>
    </template>
  </div>
</template>


<script>
  import FeedbackItemDisplay from '@/components/cards/FeedbackCard'
  import FeedItemDisplay from '@/components/cards/FeedItem'
  import ManagerFeedItemDisplay from '@/components/cards/ManagerFeedItem'
  import PagingInput from '@/components/inputs/PagingInput'
  import ResponsiveTable from '@/components/ui/ResponsiveTable'
  import VueForm from '@/components/Form'
  import ContractorRow from '@/components/rows/Contractor'
  import OcManagerRow from '@/components/rows/OcManager'
  import CompanyManagerRow from '@/components/rows/CompanyManager'
  import CompanyPropertyRow from '@/components/rows/CompanyProperty'
  import NoteDisplay from '@/components/displays/Note'
  import QuoteNoteDisplay from '@/components/displays/QuoteNote'
  import PropertyPhotoDisplay from '@/components/displays/PropertyPhoto'
  import {
    MODIFY_FORM_VALUE,
    EDIT_DATABASE_OBJECT,
    DELETE_DATABASE_OBJECT
  } from '@/vuex/types'

  export default {
    name: 'SearchForm',
    components: {
      CompanyManagerRow,
      CompanyPropertyRow,
      ContractorRow,
      FeedItemDisplay,
      FeedbackItemDisplay,
      ManagerFeedItemDisplay,
      NoteDisplay,
      QuoteNoteDisplay,
      PagingInput,
      PropertyPhotoDisplay,
      OcManagerRow,
      ResponsiveTable,
      VueForm
    },
    props: {
      options: {
        type: Object,
        default () {
          return {
            permalink: false,
            title: 'Loading Form...',
            submit: 'Loading...',
            submitting: 'Processing...',
            confirmation: false,
            redirect: '/',
            params: false
          }
        }
      },
      results: {
        type: Array,
        default () {
          return []
        }
      },
      type: {
        type: String,
        default () {
          return ''
        }
      },
      noResults: {
        type: String,
        default () {
          return 'No results'
        }
      },
      columns: {
        type: Array,
        default () {
          return [
            { title: 'ID', span: 4 },
            { title: 'Data', span: 4 },
            { title: 'Status', span: 4 }
          ]
        }
      },
      totalResults: {
        type: Number,
        default () {
          return 0
        }
      },
      tableDisplay: {
        type: Boolean,
        default () {
          return false
        }
      },
      showDates: {
        type: Boolean,
        default () {
          return false
        }
      },
      allowToggle: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    computed: {
      formOptions () {
        return {
          fullWidth: true,
          ...this.options
        }
      },
      current () {
        return this.currentPage || 1
      }
    },
    data () {
      return {
        searchHidden: true,
        currentPage: false,
        limit: 10
      }
    },
    methods: {
      isNewDay (object, index) {
        if (index === 0) {
          return true
        } else if (moment(object.createdAt).format('DD/MM/YYYY') === moment(this.results[index - 1].createdAt).format('DD/MM/YYYY')) {
          return false
        } else {
          return true
        }
      },
      toggleSearch () {
        this.searchHidden = !this.searchHidden
      },
      async search () {
        this.currentPage = 1
        this.$store.commit(MODIFY_FORM_VALUE, {
          permalink: this.options.permalink,
          name: 'offset',
          value: 0
        })
        this.refresh()
      },
      async refresh () {
        await this.$nextTick()
        this.$refs.searchForm.submitForm()
        for (let section of this.$refs.searchForm.form.sections) {
          if (section.name === 'limit') this.limit = section.value
        }
      },
      async updatePage (page) {
        this.currentPage = page
        this.$store.commit(MODIFY_FORM_VALUE, {
          permalink: this.options.permalink,
          name: 'offset',
          value: (page - 1) * this.limit
        })
        this.refresh()
      },
      parseType (permalink) {
        switch (permalink) {
          case 'getLiveFeed':
            return 'feed-item'
          case 'getOCManagersFeed':
            return 'manager-feed-item'
          case 'getPropertyNotes':
            return 'note'
          case 'getQuoteNotes':
            return 'quote-note'
          case 'getPropertyPhotos':
            return 'property-photo'
          case 'getPropertyContractors':
          case 'getCompanyContractors':
            return 'contractor'
          case 'getCompanyManagers':
            return 'company-manager'
          case 'getCompanyProperties':
            return 'company-property'
          case 'getFeedback':
            return 'feedback-item'
        }
      },
      async editObject (payload) {
        await this.$store.dispatch(EDIT_DATABASE_OBJECT, payload)
      },
      async deleteObject (payload) {
        await this.$store.dispatch(DELETE_DATABASE_OBJECT, payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue